import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1";

export const createTask = async (payload) => {
    const response = await axios.post(
        `${BASE_URL}/create/task`,
        payload,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    return response.data;
};

export const fetchTasks = async (status) => {
    const res = await axios.post(
        `${BASE_URL}/fetch/tasks/all`,
         {status},
         {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    console.log(res.data);
    return res.data;
};

export const fetchSingleTask = async (taskId) => {
    console.log(taskId);
    const res = await axios.post(
        `${BASE_URL}/fetch/tasks/single`,
         {taskId: taskId},
         {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    console.log("RESPONSE: ");
    return res.data;
};

export const updateTaskStatus = async (payload) => {
    const res = await axios.post(
        `${BASE_URL}/tasks/update/status`,
        payload,
        { headers: { "Content-Type": "application/json" } }
    );
    return res.data;
};


export const approveTask = (taskId) => {
  return axios.post(
    "https://fundi-backend.ngrok.app/api/v1/tasks/approve",
    { taskId },
     {
            headers: {
                "Content-Type": "application/json",
            },
        }
  );
};

export const assignTechnician = (taskId, technicianId) => {
    return axios.post(
        `${BASE_URL}/tasks/assign-technician`,
        { taskId, technicianId }
    );
};
